import { gql } from '@apollo/client';

export const USER_ACTION_SCORE_SUMMARY_RESULT_FRAGMENT = gql`
  fragment UserActionScoreSummaryResultFields on UserActionScoreSummaryResult {
    actionType
    adjusted
    loggedAt
    evaluationSummary {
      numEvaluators
      numScores
      numSkills
      numDrills
    }
  }
`;

export const GET_PLAYER_SCORE_SUMMARY_HISTORY = gql`
  query GetPlayerScoreSummaryHistory($playerAssessmentId: ID!) {
    playerScoreSummaryHistory(playerAssessmentId: $playerAssessmentId) {
      ...UserActionScoreSummaryResultFields
    }
  }

  ${USER_ACTION_SCORE_SUMMARY_RESULT_FRAGMENT}
`;